import React from 'react'
import { CourtProps } from '.'
import {
  CourtContainer,
  CourtContentContainer,
  CourtCount,
  CourtItemContainer,
  CourtPrice,
  CourtTitle,
} from './Court.styled'
import SVG from 'react-inlinesvg'
import courtIcon from 'assets/icons/courts.svg'
import Button from 'components/Button/Button'
import BallIcon from 'icons/Ball'

const Court = ({ title, qty, price, onHandlePrograms }: CourtProps) => {
  return (
    <CourtContainer>
      <SVG src={courtIcon}></SVG>
      <CourtItemContainer>
        <CourtContentContainer>
          <CourtCount>{qty} Courts</CourtCount>
          {price && <CourtPrice>From: $ {price} </CourtPrice>}
        </CourtContentContainer>
        <CourtTitle>{title}</CourtTitle>
      </CourtItemContainer>
      {onHandlePrograms && (
        <CourtItemContainer>
          <Button
            LeftIcon={BallIcon}
            text={'Programs'}
            size={'medium'}
            variant={'primary'}
            onClick={onHandlePrograms}
          />
        </CourtItemContainer>
      )}
    </CourtContainer>
  )
}

export default Court
